import Ordering from "./Ordering";

/**
 * Пинът за акаунта за общ достъп вече се иска глобално в `SharedAccountGate`
 * (route guard), а не само тук — затова до този компонент се стига само когато
 * акаунтът е личен или служителят вече е въвел код. Оставен е като тънка обвивка,
 * за да не се пипа route таблицата в `main.tsx`.
 */
export default function OrderingWithCode() {
  return <Ordering />;
}
